{
  "title": "My approvals",
  "status": {
    "IN_PROGRESS": "Awaiting approval",
    "BLOCKED": "Blocked",
    "ACTION_PENDING": "Finishing",
    "ACTION_FAILED": "Action failed",
    "APPROVED": "Approved",
    "REJECTED": "Rejected",
    "RETURNED": "Returned",
    "CANCELLED": "Cancelled",
    "SUPERSEDED": "Superseded"
  },
  "subject": {
    "purchase": "Purchase",
    "project_budget": "Project budget",
    "project_variation": "Project variation",
    "project_claim": "Progress claim",
    "service_contract": "Maintenance contract"
  },
  "tabs": {
    "label": "Approval views",
    "waiting": "Waiting for me",
    "submitted": "Submitted by me",
    "completed": "Completed",
    "delegations": "Delegations"
  },
  "inbox": {
    "intro": "Documents that need your decision, and the requests you sent.",
    "document": "Document",
    "requester": "Requested by",
    "step": "Step",
    "due": "Due",
    "amount": "Amount",
    "waitingSince": "Waiting since",
    "workflow": "Workflow",
    "submittedAt": "Submitted",
    "decision": "Your decision",
    "decidedAt": "Decided",
    "outcome": "Request",
    "stepOf": "Step {{index}} of {{total}}",
    "stepOfNamed": "Step {{index}} of {{total}} · {{name}}",
    "onBehalfOf": "On behalf of {{name}}",
    "overdue": "Overdue",
    "overdueSince": "Overdue since {{date}}",
    "dueOn": "Due {{date}}",
    "noDueDate": "No due date",
    "finished": "Finished",
    "tableWaiting": "Approvals waiting for me",
    "tableSubmitted": "Requests I submitted",
    "tableCompleted": "Approvals I decided",
    "overdueCount": "{{n}} overdue",
    "empty": {
      "waiting": "Nothing is waiting for you",
      "waitingBody": "When a document needs your approval it appears here, most urgent first.",
      "submitted": "You have not submitted anything for approval",
      "submittedBody": "Documents you send for approval, and where each one is, appear here.",
      "completed": "No decisions yet",
      "completedBody": "The approvals you approved, returned or rejected are kept here."
    },
    "overdueBy": "Overdue by {{duration}}",
    "dueSoon": "Due {{when}}",
    "summary": {
      "label": "At a glance",
      "toDecide": "To decide",
      "noneOverdue": "None overdue",
      "allClear": "All caught up",
      "open": "My requests",
      "openDetail": "In progress",
      "decided": "My decisions",
      "decidedDetail": "All time",
      "delegations": "Delegations",
      "delegationsDetail": "Active now"
    },
    "stepShort": "{{index}} of {{total}}"
  },
  "decision": {
    "APPROVED": "Approved",
    "REJECTED": "Rejected",
    "RETURNED": "Returned"
  },
  "request": {
    "back": "My approvals",
    "submittedBy": "Submitted by {{name}} {{when}}",
    "submittedByAt": "Submitted by {{name}}",
    "progress": "Approval progress",
    "notFound": "This request is not available",
    "notFoundBody": "It may have been withdrawn, or it is not one you take part in.",
    "stepMeter": "Step {{index}} of {{total}}",
    "withdraw": "Withdraw request",
    "withdrawTitle": "Withdraw this request?",
    "withdrawBody": "The approvers’ tasks close and the document can be edited again. You can submit it again later.",
    "withdrawn": "Request withdrawn",
    "blocked": {
      "NO_ELIGIBLE_APPROVER": "No one can approve this step right now. An administrator must reassign it or update the workflow.",
      "NO_STEP_APPLIES": "No approval step applies to this document. An administrator must update the workflow."
    },
    "actionFailed": "Approved, but the action after approval failed. An administrator can retry it.",
    "actionPending": "Approved. The action after approval is running.",
    "previous": "Earlier request",
    "next": "Later request",
    "subjectOff": {
      "purchase": "Purchasing is turned off for your company, so this request is on hold: no one can approve, reject, withdraw or recover it until Purchasing is turned back on.",
      "project_budget": "Projects is turned off for your company, so this request is on hold: no one can approve, reject, withdraw or recover it until Projects is turned back on.",
      "project_variation": "Projects is turned off for your company, so this request is on hold: no one can approve, reject, withdraw or recover it until Projects is turned back on.",
      "project_claim": "Projects is turned off for your company, so this request is on hold: no one can approve, reject, withdraw or recover it until Projects is turned back on.",
      "service_contract": "Maintenance contracts are turned off for your company, so this request is on hold: no one can approve, reject, withdraw or recover it until they are turned back on."
    }
  },
  "document": {
    "title": "The document",
    "party": "Supplier",
    "customer": "Customer",
    "reference": "Reference",
    "amount": "Amount",
    "lines": "Lines",
    "description": "Description",
    "quantity": "Qty",
    "lineAmount": "Amount",
    "open": "Open the purchase",
    "changed": "This document changed after it was submitted.",
    "changedBody": "What you see is the document as it is now. Decisions still apply to this request.",
    "noLines": "No lines",
    "openBudget": "Open the budget",
    "budgetReason": "Why this version",
    "budgetChange": "Change from the approved budget",
    "budgetFirst": "First budget: its whole cost",
    "budgetIncrease": "(an increase)",
    "hidden": "You may not read this document’s details.",
    "openVariation": "Open the variation",
    "openClaim": "Open the claim",
    "amountVariation": "Variation value (ex-VAT)",
    "amountClaim": "Net applied for (ex-VAT)",
    "openContract": "Open the contract",
    "amountContract": "Contract value (ex-VAT)",
    "contractPeriod": "Period",
    "contractSites": "Sites",
    "contractAssets": "Covered assets",
    "contractRenews": "Renews"
  },
  "steps": {
    "title": "Steps",
    "any": "Any one of these people can approve",
    "all": "Everyone listed must approve",
    "waitingFor": "Waiting for",
    "startsLater": "Starts when the step before it is approved",
    "skipped": "Skipped: its condition did not apply to this document",
    "noApprovers": "No one was assigned",
    "dueOn": "Due {{date}}",
    "decidedBy": "by {{name}}",
    "onBehalfOf": "{{name}} on behalf of {{assignee}}",
    "notEligible": "Cannot decide now",
    "status": {
      "PENDING": "Not started",
      "ACTIVE": "In progress",
      "APPROVED": "Approved",
      "SKIPPED": "Skipped",
      "REJECTED": "Rejected",
      "RETURNED": "Returned",
      "CANCELLED": "Cancelled"
    },
    "task": {
      "PENDING": "Waiting",
      "APPROVED": "Approved",
      "REJECTED": "Rejected",
      "RETURNED": "Returned",
      "CLOSED": "Not needed",
      "REASSIGNED": "Reassigned"
    },
    "progress": "{{done}} of {{total}} done"
  },
  "timeline": {
    "title": "History",
    "system": "Sahab",
    "empty": "Nothing has happened yet.",
    "onBehalfOf": "on behalf of {{name}}",
    "event": {
      "SUBMITTED": "{{actor}} submitted it for approval",
      "STEP_ACTIVATED": "“{{step}}” started",
      "STEP_SKIPPED": "“{{step}}” was skipped: its condition did not apply",
      "STEP_COMPLETED": "“{{step}}” was approved",
      "TASK_APPROVED": "{{actor}} approved",
      "TASK_REJECTED": "{{actor}} rejected it",
      "TASK_RETURNED": "{{actor}} returned it for changes",
      "BLOCKED": "Stopped: no one can approve “{{step}}”",
      "APPROVERS_REFRESHED": "{{actor}} refreshed who can approve",
      "REASSIGNED": "{{actor}} reassigned a task",
      "REMINDER_DUE": "A reminder was sent to the approvers",
      "OVERDUE": "“{{step}}” passed its due time",
      "APPROVED": "Every step approved",
      "ACTION_QUEUED": "The action after approval was queued",
      "ACTION_SUCCEEDED": "The action after approval completed",
      "ACTION_FAILED": "The action after approval failed",
      "ACTION_RETRIED": "{{actor}} retried the action after approval",
      "DOCUMENT_ACTED": "{{actor}} completed the document",
      "CANCELLED": "{{actor}} cancelled the request",
      "WITHDRAWN": "{{actor}} withdrew the request",
      "SUPERSEDED": "Replaced: the document changed after submission"
    },
    "anyStep": "a step"
  },
  "decide": {
    "title": "Your decision",
    "hint": "You are asked to approve this {{subject}} at “{{step}}”.",
    "hintDelegated": "You decide on behalf of {{name}} at “{{step}}”.",
    "notEligible": "The system may refuse your decision: you are no longer eligible for this step.",
    "approve": "Approve",
    "return": "Return for changes",
    "reject": "Reject",
    "approveTitle": "Approve this request?",
    "approveBody": "Your approval is recorded with your name. If this is the last step, the document moves on.",
    "returnTitle": "Return for changes",
    "returnBody": "The requester can edit the document and submit it again.",
    "rejectTitle": "Reject this request",
    "rejectBody": "The request stops here and the requester sees your reason. The purchase cannot be resubmitted unchanged; if a change would make it acceptable, return it for changes instead.",
    "comment": "Comment",
    "commentOptional": "Comment (optional)",
    "reason": "Reason",
    "reasonHint": "At least 3 characters. The requester sees it.",
    "reasonRequired": "Give a reason of at least 3 characters",
    "approved": "Approved",
    "returned": "Returned for changes",
    "rejected": "Rejected",
    "lastStepPost": "This is the last step: the purchase will be posted (goods received, bill recorded).",
    "lastStepApprove": "This is the last step: the purchase will be approved and ready to post.",
    "lastStepBudget": "This is the last step: the budget will be approved and become the project’s baseline.",
    "returnInstead": "Return for changes instead",
    "lastStepVariation": "This is the last step: the variation will be submitted to the client.",
    "lastStepClaim": "This is the last step: the claim will be numbered and submitted to the client.",
    "lastStepContract": "This is the last step: the contract will be activated. It starts covering jobs and its plans make the planned visits."
  },
  "errors": {
    "TASK_CLOSED": "This task is already closed: someone else decided, or the request moved on.",
    "RUN_NOT_ACTIVE": "This request is no longer waiting for a decision.",
    "NOT_ELIGIBLE": "You can no longer decide on this step (your permissions or role changed).",
    "SELF_APPROVAL": "You cannot approve a document you submitted.",
    "ALREADY_DECIDED_IN_STEP": "You already decided on an earlier step of this request.",
    "NOT_FOUND": "This task is not yours, or it no longer exists.",
    "APPROVAL_PENDING": "The document is waiting for approval and cannot be changed now.",
    "APPROVAL_ON_HOLD": "Approval workflows are turned off for your company, so this document’s approval request is on hold. The document stays locked until they are turned back on.",
    "APPROVAL_REQUIRED": "This document must be approved before it can be posted.",
    "APPROVAL_STALE": "The document changed after it was approved. Submit it again.",
    "APPROVAL_REJECTED_UNCHANGED": "Change the document before you submit it again: it was rejected as it is.",
    "NO_APPROVAL_NEEDED": "No approval workflow applies to this document. You can post it.",
    "DELEGATION_INVALID": "This delegation is not possible. Check the person and the dates.",
    "VERSION_CONFLICT": "Someone changed this in the meantime. Reload it and try again.",
    "WORKFLOW_INVALID": "The workflow cannot do this as configured. Check its steps, then try again.",
    "IMPERSONATION_RESTRICTED": "You are signed in as this user from the super-admin console. Their approval decisions and delegations stay theirs."
  },
  "delegations": {
    "intro": "Let someone else decide your approvals while you are away.",
    "new": "Delegate my approvals",
    "table": "My delegations",
    "direction": "Delegation",
    "to": "To {{name}}",
    "from": "From {{name}}",
    "period": "Period",
    "periodValue": "{{from}} – {{to}}",
    "documents": "Documents",
    "allDocuments": "All document types",
    "reason": "Reason",
    "state": "State",
    "stateLabel": {
      "current": "Active",
      "upcoming": "Upcoming",
      "past": "Ended",
      "revoked": "Revoked"
    },
    "revoke": "Revoke",
    "revokeTitle": "Revoke this delegation?",
    "revokeBody": "{{name}} can no longer decide your approvals. Decisions already made stay.",
    "revoked": "Delegation revoked",
    "rowActions": "Actions for the delegation to {{name}}",
    "empty": "No delegations",
    "emptyBody": "Going on leave? Delegate your approvals to a colleague for the dates you are away.",
    "form": {
      "title": "Delegate my approvals",
      "description": "The person you choose can approve, return or reject in your place between these dates. You keep your own access.",
      "delegate": "Delegate to",
      "delegatePlaceholder": "Choose a colleague",
      "noDelegates": "No colleague can take your approvals.",
      "startsAt": "From",
      "endsAt": "Until",
      "subject": "Documents",
      "reason": "Reason",
      "reasonPlaceholder": "e.g. Annual leave",
      "save": "Delegate",
      "created": "Approvals delegated to {{name}}",
      "chooseDelegate": "Choose who decides for you",
      "chooseStart": "Choose when it starts",
      "chooseEnd": "Choose when it ends",
      "endAfterStart": "The end must be after the start",
      "from": "Delegate the approvals of",
      "fromPlaceholder": "Choose a person",
      "chooseFrom": "Choose whose approvals are delegated",
      "samePerson": "Choose two different people"
    },
    "revokeNamed": "Revoke the delegation to {{name}}",
    "newShort": "Delegate"
  },
  "panel": {
    "label": "Approval",
    "needed": "This purchase needs approval before it can be posted.",
    "neededWorkflow": "Workflow: {{name}}",
    "waiting": "Waiting for “{{step}}” · step {{index}} of {{total}}",
    "waitingShort": "Awaiting approval",
    "submittedBy": "Submitted by {{name}} on {{date}}",
    "blocked": "Approval is stuck: no one can approve “{{step}}”.",
    "blockedBody": "An administrator must reassign the step or update the workflow.",
    "noStep": "Approval is stuck: no approval step applies.",
    "actionPending": "Approved; posting…",
    "actionFailed": "Approved, but posting failed.",
    "actionFailedBody": "An administrator can retry it from the approval monitor.",
    "approved": "Approved — ready to post",
    "approvedBody": "Approved on {{date}}.",
    "rejected": "Rejected",
    "returned": "Returned for changes",
    "reason": "Reason: {{reason}}",
    "editResubmit": "Edit the purchase if needed, then submit it again.",
    "stale": "The purchase changed after it was approved. Submit it again.",
    "cancelled": "The approval request was withdrawn. Submit it again when it is ready.",
    "viewRequest": "View request",
    "review": "Review and decide",
    "withdraw": "Withdraw",
    "locked": "Editing and posting are locked while the request is open.",
    "submit": "Submit for approval",
    "resubmit": "Submit again",
    "submitted": "Submitted for approval",
    "noLongerNeeded": "No approval is needed any more. You can post it.",
    "onHoldStamp": "On hold",
    "onHold": "On hold: approval workflows are turned off for your company.",
    "onHoldBody": "This request is frozen: no one can approve, reject or withdraw it. The purchase stays locked — it cannot be edited, posted or deleted — until approval workflows are turned back on. Ask your administrator to have them turned back on.",
    "off": "Approval workflows are turned off for your company: this purchase posts directly.",
    "offRejected": "This version was rejected. Change the purchase before posting it."
  },
  "nav": {
    "badge": "{{n}} waiting",
    "badgeOverdue": "{{n}} waiting, {{overdue}} overdue"
  },
  "monitor": {
    "title": "Approval requests",
    "intro": "Every approval request in the company: find the ones that are stuck and get them moving.",
    "back": "Approval requests",
    "table": "Approval requests",
    "views": {
      "label": "Request views",
      "attention": "Needs attention",
      "active": "Open",
      "closed": "Finished",
      "all": "All"
    },
    "filters": {
      "status": "Status",
      "allStatuses": "All statuses",
      "subject": "Document type",
      "allSubjects": "All document types",
      "search": "Search requests",
      "searchPlaceholder": "Search by document…",
      "workflow": "Workflow: {{name}}",
      "workflowUnknown": "One workflow",
      "clearWorkflow": "Show every workflow",
      "clear": "Clear filters"
    },
    "columns": {
      "document": "Document",
      "amount": "Amount",
      "workflow": "Workflow",
      "status": "Status",
      "step": "Step",
      "waiting": "Waiting",
      "lastEvent": "Last event",
      "requester": "Requested by",
      "submitted": "Submitted"
    },
    "workflowVersion": "{{name}} · v{{version}}",
    "overdue": "Overdue",
    "empty": {
      "attention": "Nothing needs attention",
      "attentionBody": "No request is blocked, failed or overdue.",
      "other": "No requests",
      "otherBody": "No approval request matches these filters."
    },
    "explain": {
      "blocked": "Blocked: no eligible approver for “{{step}}”.",
      "blockedNoStep": "Blocked: no approval step applies to this document.",
      "blockedHint": "Reassign the step to someone who can approve it, or fix the roles and refresh the approvers.",
      "excludedTitle": "Left out when the step started",
      "missing": "Users or roles in the workflow that no longer exist: {{n}}",
      "failed": "Final approval recorded; the action after approval failed.",
      "failedHint": "Fix the cause, then retry the action after approval.",
      "attempts": "Attempts so far: {{n}}",
      "overdue": "“{{step}}” has been overdue since {{date}}.",
      "details": "Details: {{message}}",
      "missingUser": "A user who no longer exists ({{id}})",
      "missingRole": "A role that no longer exists ({{id}})",
      "missingTitle": "Named in the workflow but gone"
    },
    "exclusion": {
      "REQUESTER": "submitted the request",
      "USER_INACTIVE": "inactive user",
      "MISSING_PERMISSION": "does not have permission to approve purchases",
      "PRIOR_APPROVER": "approved an earlier step",
      "NOT_ASSIGNED": "not assigned to this step",
      "YOURSELF": "that is you",
      "DELEGATES_TO_YOU": "has delegated their approvals to you",
      "ALREADY_IN_STEP": "already approves this step",
      "SUBJECT_MODULE_OFF": "Purchasing is turned off for your company"
    },
    "eligibleNow": "Can decide now",
    "notEligibleNow": "Cannot decide now: {{reason}}",
    "actions": {
      "reassign": "Reassign",
      "refresh": "Refresh approvers",
      "retry": "Retry the action after approval",
      "cancel": "Cancel request",
      "more": "More actions"
    },
    "reassign": {
      "title": "Reassign the approval",
      "body": "The person you choose gets the task now; the person it is taken from can no longer decide it.",
      "task": "Task",
      "taskOf": "{{name}}’s task",
      "addApprover": "Add an approver to “{{step}}”",
      "to": "Assign to",
      "toPlaceholder": "Choose a person",
      "reason": "Reason",
      "reasonHint": "At least 3 characters. It is kept in the history.",
      "confirm": "Reassign",
      "done": "Reassigned to {{name}}",
      "chooseTask": "Choose the task to reassign",
      "choosePerson": "Choose who gets it",
      "noCandidates": "No one can take this task."
    },
    "refresh": {
      "title": "Refresh the approvers?",
      "body": "Sahab works out who approves “{{step}}” again from the workflow: people who can now approve get a task, and people who no longer can lose theirs.",
      "confirm": "Refresh approvers",
      "done": "Approvers refreshed"
    },
    "retry": {
      "title": "Retry the action after approval?",
      "body": "The action after approval (posting the purchase) runs again now. If its cause is not fixed, it fails again.",
      "confirm": "Retry",
      "done": "Action after approval retried"
    },
    "cancel": {
      "title": "Cancel this request?",
      "body": "The approvers’ tasks close and the document is unlocked. The requester has to submit it again.",
      "reason": "Reason",
      "confirm": "Cancel request",
      "keep": "Keep request",
      "done": "Request cancelled"
    },
    "eventShort": {
      "SUBMITTED": "Submitted",
      "STEP_ACTIVATED": "Step started",
      "STEP_SKIPPED": "Step skipped",
      "STEP_COMPLETED": "Step approved",
      "TASK_APPROVED": "Approved by a person",
      "TASK_REJECTED": "Rejected",
      "TASK_RETURNED": "Returned for changes",
      "BLOCKED": "Blocked",
      "APPROVERS_REFRESHED": "Approvers refreshed",
      "REASSIGNED": "Reassigned",
      "REMINDER_DUE": "Reminder sent",
      "OVERDUE": "Became overdue",
      "APPROVED": "Fully approved",
      "ACTION_QUEUED": "Action after approval queued",
      "ACTION_SUCCEEDED": "Action after approval completed",
      "ACTION_FAILED": "Action after approval failed",
      "ACTION_RETRIED": "Action after approval retried",
      "DOCUMENT_ACTED": "Document completed",
      "CANCELLED": "Cancelled",
      "SUPERSEDED": "Superseded"
    },
    "delegations": {
      "title": "Approval delegations",
      "intro": "Every delegation in the company: who decides for whom, and when.",
      "new": "New delegation",
      "table": "Delegations",
      "from": "From",
      "to": "To",
      "createdBy": "Created by",
      "userFilter": "Person",
      "allUsers": "Everyone",
      "views": {
        "label": "Delegation views",
        "all": "All",
        "current": "Active",
        "upcoming": "Upcoming",
        "past": "Ended"
      },
      "empty": "No delegations",
      "emptyBody": "Delegations people create, or that you create for them, appear here.",
      "rowActions": "Actions for the delegation from {{from}} to {{to}}",
      "revokeBody": "{{to}} can no longer decide {{from}}’s approvals. Decisions already made stay."
    },
    "failure": {
      "PERIOD_LOCKED": "The purchase date falls on or before the lock date, so the books refused the posting. Move the lock date or change the purchase date.",
      "SUPPLIER_INACTIVE": "The supplier is inactive or archived, so the purchase cannot be posted. Reactivate the supplier.",
      "APPROVAL_STALE": "The purchase changed after it was approved, so it was not posted. It has to be submitted again.",
      "DATA_RULE": "The purchase breaks a rule of the books (for example a missing account), so it was not posted. Correct the purchase.",
      "other": "The posting was refused. Check the purchase, then retry.",
      "lockDate": "Open the lock date setting",
      "lockDateAsk": "Ask someone who manages the lock date (Settings › Lock date) to move it.",
      "lockDateOff": "Accounting is turned off for your company, so nobody here can move the lock date. Ask your provider, or change the purchase date."
    },
    "stepBlocked": "Blocked"
  },
  "label": "{{type}} · {{label}}",
  "resolution": {
    "via": "Found as {{how}}",
    "fallback": "From the fallback role: no {{who}} could approve",
    "levelUp": " (level +{{n}})",
    "assignee": {
      "HEAD_OF": {
        "subject": "head of the document’s unit",
        "requester": "head of the requester’s unit"
      },
      "HRBP_OF": {
        "subject": "HR business partner of the document’s unit",
        "requester": "HR business partner of the requester’s unit"
      }
    },
    "walksTitle": "Passed over on the way up",
    "walksLabel": "How the approver was found",
    "unknownUnit": "an unknown unit",
    "reason": {
      "VACANT": "no head",
      "NO_UNIT": "the unit is not known",
      "FALLBACK": "no head could approve: the fallback role decides",
      "VACANT_HRBP": "no HR business partner",
      "FALLBACK_HRBP": "no HR business partner could approve: the fallback role decides",
      "REQUESTER": "submitted the request",
      "USER_INACTIVE": "inactive user",
      "MISSING_PERMISSION": "does not have permission to approve",
      "PRIOR_APPROVER": "approved an earlier step",
      "NOT_ASSIGNED": "not assigned to this step",
      "SUBJECT_MODULE_OFF": "the document’s module is turned off"
    }
  }
}
